import React, { useEffect, useState } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Box,
  Snackbar,
  Alert,
  AppBar,
  Typography,
  IconButton,
  Toolbar,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSearchParams } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

import StepOnePersonalInfo from "./StepOnePersonalInfo";
import StepTwoDiagnosisForm from "./StepTwoDiagnosisForm";
import StepThreeAssesment from "./StepThreeAssesment";
import StepFourHHCServiceRef from "./StepFourHHCServiceRef";
import { API_URL } from "../../../Config/api";

const sectionsmap = [
  { label: "HEENT", key: "heent" },
  { label: "Neck", key: "neck" },
  { label: "Chest", key: "chest" },
  { label: "Abdomen", key: "abdomen" },
  { label: "Pelvis", key: "pelvis" },
  { label: "Back", key: "back" },
  { label: "Upper Limb", key: "upper_limb" },
  { label: "Lower Limb", key: "lower_limb" },
  { label: "General", key: "general" },
];

const MedicalForm = ({ onClose = () => {}, eventId, fetchFormData }) => {
  // const port = process.env.REACT_APP_API_KEY;
  const accessToken = localStorage.getItem("token");
  console.log("eventId", eventId);

  const [activeStep, setActiveStep] = useState(0);
  const [service, setService] = useState([]);
  const [searchParams] = useSearchParams();
  const isUrlMode = searchParams.has("event_id");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [formData, setFormData] = useState({
    /* ================= BASIC ================= */
    eve_id: eventId,

    name: "",
    phone_no: "",
    dob: "",
    Age: "",
    Age_month:"",
    Age_day:"",
    gender_id: "",
    marital_status: "",
    blood_group: "",
    height: "",
    weight: "",
    identification_mark: "",
    insurance: "",
    state_id: "",
    address: "",
    city_id: "",
    pincode: "",

    /* ================= FAMILY / SPOUSE ================= */
    spouse_name: "",
    spouse_phone: "",
    spouse_email: "",

    family_doctor: "",
    family_doctor_phone: "",
    family_doctor_email: "",

    /* ================= MEDICAL ================= */
    allergies: "",
    vaccinations: "",
    diagnosis: "",
    instruction_for_patient: "",

    past_medical_history: [],
    other_past_medical_history:"", // [1,2,3]

    /* ================= LIFESTYLE ================= */
    tobacco: false,
    tobacco_remark: "",
    alcohol: false,
    alcohol_remark: "",

    /* ================= CONSULTANTS ================= */
    hosp_id: "",
    primary_consultant_name: "",
    primary_consultant_email: "",
    other_consultant_name: "",
    other_consultant_phone: "",
    other_consultant_email: "",

    doctor_name: "",

    reffered_by: "",
    reffered_by_phone: "",
    reffered_by_email: "",

    /* ================= HOSPITALIZATION ================= */
    hosp_id: "",
    hospitalization_from: "",
    hospitalization_to: "",

    /* ================= CTP ================= */
    ctp_tablet: "",
    ctp_injection: "",
    ctp_iv_fluids: "",
    ctp_interventions: "",
    ctp_notes: "",

    /* ================= FI ================= */
    fi_physical: "",
    fi_investigations: "",
    fi_interventions: "",
    fi_assistance: "",

    /* ================= ASSESSMENT ================= */
    assessment_place: "",

    baseline: "",
    airway: "",
    breathing: "",
    circulation: "",

    temp: "",
    pulse: "",
    rr: "",
    bp: "",
    bsl: "",
    spo2: "",
    gst_total: "",
    skin_perfusion: "",
    recent_invesigation_cbc: "",
    rft: "",
    bsl_remark: "",
    electrocycles: "",
    other: "",

    /* ================= SYSTEM EXAM ================= */
    heent: false,
    heent_remark: "",

    neck: false,
    neck_remark: "",

    chest: false,
    chest_remark: "",

    abdomen: false,
    abdomen_remark: "",

    pelvis: false,
    pelvis_remark: "",

    back: false,
    back_remark: "",

    upper_limb: false,
    upper_limb_remark: "",

    lower_limb: false,
    lower_limb_remark: "",

    general: false,
    general_remark: "",
    General_Body_Notes: "",
    patient_body_remarks: "",

    clinical_impression: "",
    form_fillup_date: "",

    /* ================= SERVICES ================= */
    services: [], // [1,4,5,6,7,8,9,10,11]
    sub_services: [], // [2,3,12,14]

    /* ================= FILE ================= */
    patient_image: null,
    patient_signature: null,
    physician_signature: null,
  });

  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const steps = [
    { label: "Patient Details", icon: <PersonIcon /> },

    { label: "Recent Hospitalizations Details", icon: <LocalHospitalIcon /> },

    { label: "Assessment by Physician", icon: <AssignmentIcon /> },

    { label: "HHC Service Reference", icon: <FavoriteBorderIcon /> },
  ];

const handleStepClick = (index) => {
  const isValid = validateForm(activeStep);

  if (!isValid) {
      setSnackbar({
        open: true,
        message: "Please complete required fields before proceeding",
        severity: "error",
      });
 
    return;
  }

  setActiveStep(index);
};

  const handleClose = () => {
    onClose?.();
  };

  // Universal Change Handler
  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const phoneRegex = /^[6-9]\d{9}$/; // Indian mobile
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validateForm = (step) => {
    let errors = {};

    /* ================= STEP 0 : PERSONAL & MEDICAL ================= */
    if (step === 0) {
      if (!formData.name) errors.name = "Name required";

      if (!formData.phone_no) errors.phone_no = "Phone required";
      else if (!phoneRegex.test(formData.phone_no))
        errors.phone_no = "Invalid phone number";

      if (!formData.dob) errors.dob = "DOB required";
      else if (new Date(formData.dob) > new Date())
        errors.dob = "DOB cannot be in the future";

      if (!formData.gender_id) errors.gender_id = "Gender required";
      if (!formData.marital_status)
        errors.marital_status = "Marital status required";

      if (!formData.identification_mark)
        errors.identification_mark = "Identification mark required";

      if (!formData.city_id) errors.city_id = "City required";
      if (!formData.address) errors.address = "Address required";

      if (!formData.pincode) errors.pincode = "Pincode required";
      else if (!/^\d{6}$/.test(formData.pincode))
        errors.pincode = "Invalid pincode";

      if (!formData.allergies) errors.allergies = "Allergies required";
      if (!formData.vaccinations) errors.vaccinations = "Vaccinations required";

      if (!formData.family_doctor)
        errors.family_doctor = "Family doctor required";

      if (!formData.family_doctor_phone)
        errors.family_doctor_phone = "Family doctor phone required";
      else if (!phoneRegex.test(formData.family_doctor_phone))
        errors.family_doctor_phone = "Invalid phone number";

      // if (!emailRegex.test(formData.family_doctor_email))
      //   errors.family_doctor_email = "Invalid Family Doctor Email number";

      if (!formData.height || isNaN(formData.height) || formData.height <= 0)
        errors.height = "Invalid height";

      if (!formData.weight || isNaN(formData.weight) || formData.weight <= 0)
        errors.weight = "Invalid weight";

//  if (!Number.isInteger(formData.age) || formData.age <= 0) {
//   errors.age = "Invalid age";
// }


      if (!formData.blood_group) errors.blood_group = "Blood group required";

      if (!formData.spouse_name) errors.spouse_name = "Spouse name required";

      if (!formData.spouse_phone) errors.spouse_phone = "Spouse phone required";
      else if (!phoneRegex.test(formData.spouse_phone))
        errors.spouse_phone = "Invalid phone number";

      if (!formData.spouse_email) errors.spouse_email = "Spouse email required";
      else if (!emailRegex.test(formData.spouse_email))
        errors.spouse_email = "Invalid email";

      if (formData.tobacco && !formData.tobacco_remark)
        errors.tobacco_remark = "Tobacco remark required";

      if (formData.alcohol && !formData.alcohol_remark)
        errors.alcohol_remark = "Alcohol remark required";

      if (
        !formData.past_medical_history?.length &&
        !formData.other_past_medical_history
      ) {
        errors.past_medical_history =
          "Please select or enter at least one medical history";
      }

      if (
    formData.past_medical_history?.includes(9) &&
    !formData.other_past_medical_history?.trim()
  ) {
    errors.other_past_medical_history =
      "Please specify other medical history";
  }
    }

    /* ================= STEP 1 : HOSPITALIZATION ================= */
    if (step === 1) {
      if (!formData.diagnosis) errors.diagnosis = "Medical condition required";

      /* ================================
     PRIMARY CONSULTANT EMAIL
  ================================== */
      // if (!formData.primary_consultant_email)
      //   errors.primary_consultant_email = "Primary consultant email required";
      //  if (!emailRegex.test(formData.primary_consultant_email))
      //   errors.primary_consultant_email = "Invalid email";

      /* ================================
     HOSPITALIZATION DATES
  ================================== */
      if (!formData.hospitalization_from)
        errors.hospitalization_from = "From date required";

      if (!formData.hospitalization_to)
        errors.hospitalization_to = "To date required";

      if (
        formData.hospitalization_from &&
        formData.hospitalization_to &&
        new Date(formData.hospitalization_from) >
          new Date(formData.hospitalization_to)
      ) {
        errors.hospitalization_to = "Invalid date range";
      }

      /* ================================
     CTP DETAILS
  ================================== */
      // if (!formData.ctp_tablet)
      //   errors.ctp_tablet = "CTP Tablet details required";

      // if (!formData.ctp_injection)
      //   errors.ctp_injection = "CTP Injection details required";

      // if (!formData.ctp_iv_fluids)
      //   errors.ctp_iv_fluids = "CTP IV Fluids details required";

      // if (!formData.ctp_interventions)
      //   errors.ctp_interventions = "CTP Interventions required";

      // if (!formData.ctp_notes) errors.ctp_notes = "CTP Notes required";

      /* ================================
     REFERRED BY
  ================================== */
      if (!formData.reffered_by) errors.reffered_by = "Referred by required";

      if (!formData.reffered_by_phone)
        errors.reffered_by_phone = "Referred by phone required";
      else if (!phoneRegex.test(formData.reffered_by_phone))
        errors.reffered_by_phone = "Invalid phone number";

      if (!formData.reffered_by_email)
        errors.reffered_by_email = "Referred by email required";
      else if (!emailRegex.test(formData.reffered_by_email))
        errors.reffered_by_email = "Invalid email";

      const isPrimarySelected = Boolean(formData.primary_consultant_name);

      if (!isPrimarySelected) {
        if (!phoneRegex.test(formData.other_consultant_phone))
          errors.other_consultant_phone = "Invalid phone number";

        if (!emailRegex.test(formData.other_consultant_email))
          errors.other_consultant_email = "Invalid email";
      }
    }

    /* ================= STEP 2 : ASSESSMENT ================= */
    if (step === 2) {
      if (!formData.assessment_place)
        errors.assessment_place = "Assessment place required";

  const isAnyABCChecked =
    formData.baseline ||
    formData.airway ||
    formData.breathing ||
    formData.circulation ||
    formData.skin_perfusion; 

if (!isAnyABCChecked) {
    errors.abc =
        "Please select at least one: Baseline / Airway / Breathing / Circulation / Skin perfusion";
}

      if (!formData.doctor_name) errors.doctor_name = "Doctor name required";

      if (!formData.bp) errors.bp = "BP required";
      if (!formData.pulse) errors.pulse = "Pulse required";
      if (!formData.spo2) errors.spo2 = "SpO2 required";
      if (!formData.temp) errors.temp = "Temperature required";
      if (!formData.rr) errors.rr = "RR required";
      if (!formData.bsl) errors.bsl = "BSL required";
      if (!formData.gst_total) errors.gst_total = "GCS required";
      if (!formData.recent_invesigation_cbc) errors.recent_invesigation_cbc = "CBC required";
      if (!formData.rft) errors.rft = "RFT required";
      if (!formData.electrocycles) errors.electrocycles = "Electrolytes required";
      if (!formData.other) errors.other = "Other investigations required";
      // if (!formData.bsl_remark) errors.bsl_remark = "bsl remark required";
      // if (!formData.skin_perfusion)
      //   errors.skin_perfusion = "Skin perfusion required";

    

      if (!formData.clinical_impression)
        errors.clinical_impression = "Clinical impression required";

      const missingAssessment = sectionsmap.some(
        ({ key }) => formData[key] === null || formData[key] === undefined
      );

      if (missingAssessment) {
        errors.physical_assessment =
          "Please select Yes or No for all physical assessment sections";
      }

      if (!formData.General_Body_Notes)
        errors.General_Body_Notes = "General body notes required";
    }

    /* ================= STEP 3 : SERVICES ================= */
    if (step === 3) {
      if (!formData.services || formData.services.length === 0) {
  errors.services = "Please select at least one service";
}
      if (!formData.sub_services?.length)
        errors.sub_services = "Select at least one service";

      if (!formData.form_fillup_date) {
        errors.form_fillup_date = "Form fill-up date is required";
      } else {
        // normalize selected date
        const selectedDate = new Date(formData.form_fillup_date);
        selectedDate.setHours(0, 0, 0, 0);

        // today date
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // ❌ future date not allowed
        if (selectedDate > today) {
          errors.form_fillup_date = "Form fill-up date cannot be in the future";
        }
      }
      /* ================= SIGNATURE VALIDATION ================= */

      // Patient Signature
      if (!formData.patient_signature) {
        errors.patient_signature = "Patient signature is required";
      }

      // Physician Signature
      if (!formData.physician_signature) {
        errors.physician_signature = "Physician signature is required";
      }
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = () => {
    console.clear();

    console.log(" CURRENT STEP:", activeStep);
    console.log(" FORM DATA BEFORE VALIDATION:", formData);

    const valid = validateForm(activeStep);

    console.log(" VALIDATION RESULT:", valid);
    console.log(" VALIDATION ERRORS:", errors);

    if (!valid) {
      console.warn("❌ Validation failed. Step not changed.");
      return;
    }

    if (activeStep === steps.length - 1) {
      console.log(" LAST STEP → SUBMIT");
      handleSubmit();
      return;
    }

    console.log(" VALID → MOVING TO NEXT STEP");
    setActiveStep((prev) => prev + 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleBack = () => {
    if (activeStep > 0) setActiveStep((prev) => prev - 1);
  };

  const dataURLtoBlob = (dataURL) => {
    const [header, base64] = dataURL.split(",");
    const mime = header.match(/:(.*?);/)[1];
    const binary = atob(base64);
    const array = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
      array[i] = binary.charCodeAt(i);
    }

    return new Blob([array], { type: mime });
  };
  const buildFormDataPayload = async (data, eventId) => {
    const fd = new FormData();

    /* ================= BASIC ================= */
    fd.append("eve_id", data.eve_id || eventId);
    fd.append("name", data.name);
    fd.append("phone_no", data.phone_no);
    fd.append("dob", data.dob);
    fd.append("Age", data.Age);
    fd.append("Age_month", data.Age_month);
    fd.append("Age_day", data.Age_day);
    fd.append("gender_id", data.gender_id);
    fd.append("marital_status", data.marital_status);
    fd.append("blood_group", data.blood_group);
    fd.append("state_id", data.state_id);
    fd.append("insurance", data.insurance);

    fd.append("height", data.height);
    fd.append("weight", data.weight);
    fd.append("identification_mark", data.identification_mark);

    fd.append("address", data.address);
    fd.append("city_id", data.city_id);
    fd.append("pincode", data.pincode);

    /* ================= FAMILY ================= */
    fd.append("spouse_name", data.spouse_name);
    fd.append("spouse_phone", data.spouse_phone);
    fd.append("spouse_email", data.spouse_email);
    fd.append("hosp_id", data.hosp_id);

    fd.append("family_doctor", data.family_doctor);
    fd.append("family_doctor_phone", data.family_doctor_phone);
    fd.append("family_doctor_email", data.family_doctor_email);

    /* ================= MEDICAL ================= */
    fd.append("allergies", data.allergies);
    fd.append("vaccinations", data.vaccinations);
    fd.append("diagnosis", data.diagnosis);
    fd.append("instruction_for_patient", data.instruction_for_patient);

    fd.append(
      "past_medical_history",
      JSON.stringify(data.past_medical_history)
    );

    fd.append("other_past_medical_history", formData.other_past_medical_history || "");

    /* ================= LIFESTYLE ================= */
    fd.append("tobacco", data.tobacco ? 1 : 0);
    fd.append("tobacco_remark", data.tobacco_remark);

    fd.append("alcohol", data.alcohol ? 1 : 0);
    fd.append("alcohol_remark", data.alcohol_remark);

    /* ================= CONSULTANTS ================= */
    fd.append("primary_consultant_name", data.primary_consultant_name);

    fd.append("primary_consultant_email", data.primary_consultant_email);
    fd.append("other_consultant_name", data.other_consultant_name);
    fd.append("other_consultant_phone", data.other_consultant_phone);
    fd.append("other_consultant_email", data.other_consultant_email);

    fd.append("doctor_name", data.doctor_name);

    fd.append("reffered_by", data.reffered_by);
    fd.append("reffered_by_phone", data.reffered_by_phone);
    fd.append("reffered_by_email", data.reffered_by_email);

    /* ================= HOSPITALIZATION ================= */
    fd.append("hospitalization_from", data.hospitalization_from);
    fd.append("hospitalization_to", data.hospitalization_to);
    fd.append("hosp_id", data.hosp_id);

    /* ================= CTP ================= */
    fd.append("ctp_tablet", data.ctp_tablet);
    fd.append("ctp_injection", data.ctp_injection);
    fd.append("ctp_iv_fluids", data.ctp_iv_fluids);
    fd.append("ctp_interventions", data.ctp_interventions);
    fd.append("ctp_notes", data.ctp_notes);

    /* ================= FI ================= */
    fd.append("fi_physical", data.fi_physical);
    fd.append("fi_investigations", data.fi_investigations);
    fd.append("fi_interventions", data.fi_interventions);
    fd.append("fi_assistance", data.fi_assistance);

    /* ================= ASSESSMENT ================= */
    fd.append("assessment_place", data.assessment_place);
    fd.append("baseline", data.baseline);
    fd.append("airway", data.airway);
    fd.append("breathing", data.breathing);
    fd.append("circulation", data.circulation);

    fd.append("temp", data.temp);
    fd.append("pulse", data.pulse);
    fd.append("rr", data.rr);
    fd.append("bp", data.bp);
    fd.append("bsl", data.bsl);
    fd.append("spo2", data.spo2);
    fd.append("gst_total", data.gst_total);
    fd.append("skin_perfusion", data.skin_perfusion);
    fd.append("recent_invesigation_cbc", data.recent_invesigation_cbc);
    fd.append("rft", data.rft);
    fd.append("bsl_remark", data.bsl_remark);
    fd.append("electrocycles", data.electrocycles);
    fd.append("other", data.other);

    /* ================= SYSTEM EXAM ================= */
    const systems = [
      "heent",
      "neck",
      "chest",
      "abdomen",
      "pelvis",
      "back",
      "upper_limb",
      "lower_limb",
      "general",
    ];
    /* ================= SYSTEM EXAM ================= */
    sectionsmap.forEach(({ key }) => {
      fd.append(key, formData[key] ? 1 : 0);
      fd.append(
        `${key}_remark`,
        formData[key] ? formData[`${key}_remark`] : ""
      );
    });

    fd.append("General_Body_Notes", data.General_Body_Notes || "");

    /* ================= FINAL ================= */
    fd.append("clinical_impression", data.clinical_impression);

    /* ================= SUB-SERVICES ================= */
    fd.append("services", JSON.stringify(data.services));
    fd.append("sub_services", JSON.stringify(data.sub_services));
    fd.append("form_fillup_date", data.form_fillup_date);

    /* ================= FILE ================= */
    if (formData.patient_signature) {
      if (formData.patient_signature instanceof File) {
        fd.append("patient_signature", formData.patient_signature);
      } else if (
        typeof formData.patient_signature === "string" &&
        formData.patient_signature.startsWith("data:")
      ) {
        const blob = dataURLtoBlob(formData.patient_signature);
        fd.append("patient_signature", blob, "patient_signature.png");
      }
    }

    if (formData.physician_signature) {
      if (formData.physician_signature instanceof File) {
        fd.append("physician_signature", formData.physician_signature);
      } else if (
        typeof formData.physician_signature === "string" &&
        formData.physician_signature.startsWith("data:")
      ) {
        const blob = dataURLtoBlob(formData.physician_signature);
        fd.append("physician_signature", blob, "physician_signature.png");
      }
    }

    if (formData.patient_image) {
      // Case 1: File (best case)
      if (formData.patient_image instanceof File) {
        fd.append("patient_image", formData.patient_image);

        // Case 2: Blob (html2canvas output)
      } else if (formData.patient_image instanceof Blob) {
        fd.append("patient_image", formData.patient_image, "patient_image.png");

        // Case 3: base64 dataURL
      } else if (
        typeof formData.patient_image === "string" &&
        formData.patient_image.startsWith("data:")
      ) {
        const blob = dataURLtoBlob(formData.patient_image);
        fd.append("patient_image", blob, "patient_image.png");
      } else {
        console.warn("Invalid patient_image type:", formData.patient_image);
      }
    }

    return fd;
  };

  // SUBMIT FINAL FORM
  const handleSubmit = async () => {
    if (!validateForm(3)) return;
    try {
      const fd = await buildFormDataPayload(formData, eventId);

      const res = await fetch(`${API_URL}/web/post_form/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: fd,
      });

      const data = await res.json();
      console.log("API Response Data:", data);

      // 1️⃣ Show snackbar first
      setSnackbar({
        open: true,
        message: "Form submitted successfully",
        severity: "success",
      });

      // 2️⃣ Refresh data (optional but fine here)
      fetchFormData?.();

      // 3️⃣ Delay modal close so snackbar is visible
      setTimeout(() => {
        if (isUrlMode) {
          // URL → logical close
          setIsSubmitted(true);
        } else {
          // Modal → actual close
          onClose();
        }
      }, 1500); // 1.5 sec is UX-sweet spot
    } catch (error) {
      console.error(error);
      setSnackbar({
        open: true,
        message: "Form submission failed",
        severity: "error",
      });
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  useEffect(() => {
    // 1️⃣ eventId prop OR URL param
    const urlEventId = searchParams.get("event_id");
    const finalEventId = eventId || urlEventId;

    if (!finalEventId) return;
    console.log(finalEventId, "finalEventIdfinalEventId");

    const fetchPrefillData = async () => {
      try {
        const res = await fetch(
          `${API_URL}/web/long_term_get_idwise/${finalEventId}/`,
          {
            headers: {
              // Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        const data = await res.json();

        console.log("PREFILL API DATA:", data);

        setFormData((prev) => ({
          ...prev,

          /* ================= BASIC ================= */
          eve_id: data.eve_id,
          name: data.name || "",
          phone_no: data.phone_no || "",
          dob: data.dob ? data.dob.split("T")[0] : "",
          Age: data.Age || "",
          dob_month: data.Age_month || "",
          dob_days: data.Age_day || "",
          gender_id: data.gender_id || "",
          marital_status: data.marital_status || "",
          blood_group: data.blood_group || "",
          height: data.height || "",
          weight: data.weight || "",
          identification_mark: data.identification_mark || "",

          address: data.address || "",
          state: data.state_id || "",
          city_id: data.city_id || "",
          pincode: data.pincode || "",

          /* ================= FAMILY ================= */
          spouse_name: data.spouse_name || "",
          spouse_phone: data.spouse_phone || "",
          spouse_email: data.spouse_email || "",

          family_doctor: data.family_doctor || "",
          family_doctor_phone: data.family_doctor_phone || "",
          family_doctor_email: data.family_doctor_email || "",

          /* ================= MEDICAL ================= */
          allergies: data.allergies || "",
          vaccinations: data.vaccinations || "",
          diagnosis: data.diagnosis || "",
          instruction_for_patient: data.instruction_for_patient || "",
          insurance: data.insurance || "",

          past_medical_history: data.past_medical_history || [],
      other_past_medical_history: data.other_past_medical_history || "",


          /* ================= LIFESTYLE ================= */
          tobacco: Boolean(data.tobacco),
          tobacco_remark: data.tobacco_remark || "",
          alcohol: Boolean(data.alcohol),
          alcohol_remark: data.alcohol_remark || "",

          /* ================= CONSULTANTS ================= */
          hosp_id: data.hosp_id || "",
          primary_consultant_name: data.primary_consultant_name || "",
          primary_consultant_email: data.primary_consultant_email || "",
          other_consultant_name: data.other_consultant_name || "",
          other_consultant_phone: data.other_consultant_phone || "",
          other_consultant_email: data.other_consultant_email || "",

          hosp_id: data.hosp_id || "",

          doctor_name: data.doctor_name || "",

          reffered_by: data.reffered_by || "",
          reffered_by_phone: data.reffered_by_phone || "",
          reffered_by_email: data.reffered_by_email || "",

          /* ================= HOSPITALIZATION ================= */
          hospitalization_from: data.hospitalization_from || "",
          hospitalization_to: data.hospitalization_to || "",

          /* ================= CTP ================= */
          ctp_tablet: data.ctp_tablet || "",
          ctp_injection: data.ctp_injection || "",
          ctp_iv_fluids: data.ctp_iv_fluids || "",
          ctp_interventions: data.ctp_interventions || "",
          ctp_notes: data.ctp_notes || "",

          /* ================= FI ================= */
          fi_physical: data.fi_physical || "",
          fi_investigations: data.fi_investigations || "",
          fi_interventions: data.fi_interventions || "",
          fi_assistance: data.fi_assistance || "",

          /* ================= ASSESSMENT ================= */
          assessment_place: data.assessment_place || "",
          baseline: data.baseline || "",
          airway: data.airway || "",
          breathing: data.breathing || "",
          circulation: data.circulation || "",

          temp: data.temp || "",
          pulse: data.pulse || "",
          rr: data.rr || "",
          bp: data.bp || "",
          bsl: data.bsl || "",
          spo2: data.spo2 || "",
          gst_total: data.gst_total || "",
          skin_perfusion: data.skin_perfusion || "",
          recent_invesigation_cbc: data.recent_invesigation_cbc || "",
          rft: data.rft || "",
          bsl_remark: data.bsl_remark || "",
          electrocycles: data.electrocycles || "",
          other: data.other || "",

          /* ================= SYSTEM EXAM ================= */
          doctor_name: data.doctor_name || "",
          heent: Boolean(data.heent),
          heent_remark: data.heent_remark || "",

          neck: Boolean(data.neck),
          neck_remark: data.neck_remark || "",

          chest: Boolean(data.chest),
          chest_remark: data.chest_remark || "",

          abdomen: Boolean(data.abdomen),
          abdomen_remark: data.abdomen_remark || "",

          pelvis: Boolean(data.pelvis),
          pelvis_remark: data.pelvis_remark || "",

          back: Boolean(data.back),
          back_remark: data.back_remark || "",

          upper_limb: Boolean(data.upper_limb),
          upper_limb_remark: data.upper_limb_remark || "",

          lower_limb: Boolean(data.lower_limb),
          lower_limb_remark: data.lower_limb_remark || "",

          general: Boolean(data.general),
          general_remark: data.general_remark || "",

          clinical_impression: data.clinical_impression || "",
          General_Body_Notes: data.General_Body_Notes || "",
          notify_name: data.notify_name || "",
          form_fillup_date: data.form_fillup_date || "",

          /* ================= SERVICES ================= */
          services: data.services || [],
          sub_services: data.sub_services || [],
          /* ================= FILE ================= */
        patient_image: data.patient_image
  ? `${API_URL}${data.patient_image}`
  : null, // OK
         patient_signature: data.patient_signature
  ? `${API_URL}${data.patient_signature}`
  : null,
          physician_signature: data.physician_signature
  ? `${API_URL}${data.physician_signature}`
  : null,

          hhc_code: data.hhc_code || "",
        }));
      } catch (error) {
        console.error("❌ Prefill error:", error);
      }
    };

    fetchPrefillData();
  }, [eventId]);

  // STEP CONTENT FIX (NO PARAMETER)
  const renderFormStep = () => {
    switch (activeStep) {
      case 0:
        return (
          <Box sx={{ mt: 1, mb: 3, p: 2 }}>
            <StepOnePersonalInfo
              formData={formData}
              setFormData={setFormData}
              errors={errors}
              handleChange={handleChange}
            />
          </Box>
        );

      case 1:
        return (
          <Box sx={{ mt: 1, mb: 3, p: 2 }}>
            <StepTwoDiagnosisForm
              formData={formData}
              setFormData={setFormData}
              onChange={handleChange}
              handleChange={handleChange} // ✅ FIX
              errors={errors}
            />
          </Box>
        );

      case 2:
        return (
          <Box sx={{ mt: 1, mb: 3, p: 2 }}>
            <StepThreeAssesment
              formData={formData}
              setFormData={setFormData}
              handleChange={handleChange} // ✅ FIX
              errors={errors}
            />
          </Box>
        );

      case 3:
        return (
          <Box sx={{ mt: 1, mb: 3, p: 2 }}>
            <StepFourHHCServiceRef
              formData={formData}
              setFormData={setFormData}
              onChange={handleChange}
              errors={errors}
              handleChange={handleChange}
              // ✅ FIX
            />
          </Box>
        );

      default:
        return null;
    }
  };

  if (isUrlMode && isSubmitted) {
    return (
      <Box
        sx={{
          minHeight: "100dvh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 2,
          backgroundColor: "#fff",
        }}
      >
        <Typography variant="h5" fontWeight={600}>
          ✅ Form submitted successfully
        </Typography>

        <Typography color="text.secondary">
          You may safely close this tab.
        </Typography>
      </Box>
    );
  }

  return (
    <div
      style={{
        minHeight: isUrlMode ? "100dvh" : "100%",
        height: isUrlMode ? "auto" : "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fff",
      }}
    >
      <Snackbar
        open={snackbar.open}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <AppBar
        position="sticky"
        elevation={3}
        sx={{
          top: 0,
          zIndex: 1200,
          backgroundColor: "#A5D6A7",
          height: 48,
          justifyContent: "center",
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            minHeight: 48,
            px: 1.5,
            display: "flex",
            alignItems: "center",
          }}
        >
          {/* Left Title */}
          <Typography
            variant="subtitle1"
            sx={{
              flexGrow: 1,
              fontWeight: 600,
              letterSpacing: "0.3px",
            }}
          >
            Long Term Care Form
          </Typography>

          {/* HHC No Display */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              px: 1.5,
              py: 0.5,
              mr: 2,
              backgroundColor: "#0000",
              borderRadius: 1,
              borderBottom: "1px solid #2e7d32",
            }}
          >
            <Typography
              sx={{
                fontSize: "0.75rem",
                fontWeight: 600,
                color: "#1b5e20",
              }}
            >
              HHC No:
            </Typography>

            <Typography
              sx={{
                fontSize: "0.8rem",
                fontWeight: 700,
                color: "#000",
                letterSpacing: "0.5px",
              }}
            >
              {formData.hhc_code || "--"}
            </Typography>
          </Box>

          {/* Close Action */}
          {!isUrlMode && (
            <IconButton
              edge="end"
              size="small"
              onClick={handleClose}
              sx={{
                color: "#fff",
                "&:hover": {
                  backgroundColor: "rgba(27,94,32,0.08)",
                },
              }}
            >
              <CloseIcon fontSize="large" />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>

      <Box
        sx={{
          width: "100%",
          maxWidth: "1200px",
          mx: "auto",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          p: 1,
          overflow: isUrlMode ? "visible" : "hidden",
        }}
      >
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          sx={{
            flexShrink: 0,
            px: 0,
            mx: 0,
          }}
        >
          {steps.map(({ label, icon }, index) => (
            <Step key={label} onClick={() => handleStepClick(index)}>
              <StepLabel
                icon={React.cloneElement(icon, {
                  sx: {
                    color: activeStep === index ? "#1976D2" : "#9e9e9e",
                    transform: activeStep === index ? "scale(1.2)" : "scale(1)",
                    transition: "0.3s",
                  },
                })}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>

        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            mt: 1,
          }}
        >
          {renderFormStep()}
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",

            px: 2, // 🔑 horizontal alignment fix
            py: 1.5,

            borderTop: "1px solid #e0e0e0",
            backgroundColor: "#fff",

            flexShrink: 0, // 🔒 never collapse
          }}
        >
          <Button
            variant="outlined"
            disabled={activeStep === 0}
            onClick={handleBack}
            sx={{
              minWidth: 120,
              textTransform: "none",
              fontWeight: 500,
            }}
          >
            Back
          </Button>

          {activeStep === steps.length - 1 ? (
            <Button
              variant="contained"
              onClick={handleSubmit}
              sx={{
                minWidth: 140,
                backgroundColor: "#347B89",
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Submit
            </Button>
          ) : (
            <Button
              variant="contained"
              onClick={handleNext}
              sx={{
                minWidth: 120,
                backgroundColor: "#347B89",
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Next
            </Button>
          )}
        </Box>
      </Box>
    </div>
  );
};

export default MedicalForm;
